import ResourceService from "./resource.service";

class ServiceCategoryService extends ResourceService {
  static get resource() {
    return "service-category";
  }
}

export default ServiceCategoryService;